import { useMap } from '~map-preview/states/map'
import { PrimaryFieldInput as View } from 'ui-components'
import { get } from 'lodash'
import { useUpdateMapSettings } from '~map-settings/query/useUpdateMapSettings'
import { getPropertyOptions } from '~map-settings/libs/getPropertyOptions'

export const PrimaryField = () => {
  const map = useMap()
  const updateMapSettings = useUpdateMapSettings()

  const properties =
    map?.properties?.map((property, key) => ({
      ...property,
      id: key, // INFO: need id for drag and drop position
      visible: get(property, 'visible', true),
      options: getPropertyOptions(property)
    })) || []

  const handlePropertiesChange = async (items) => {
    if (!items?.length) return
    const newProperties = items?.map((item, key) => ({
      ...item,
      id: key
    }))
    await updateMapSettings(newProperties)
  }

  return (
    <View
      properties={properties}
      onPropertiesChange={handlePropertiesChange}
    />
  )
}
